// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-feed-selector.mobile-only {
  display: none !important;
  padding: 8px 10px;
}

.profile-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.profile-feed-selector {
  margin-bottom: 14px;
}

.profile-feed-dropdown {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 10px 12px;
}

.profile-feed-dropdown option {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.profile-header {
  aspect-ratio: 4680 / 1220;
  background-size: cover;
  background-position: center;
  background-color: var(--accent-primary);
  border-radius: 12px 12px 0 0;
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 20px;
  transition: box-shadow 0.2s ease;
}

.profile-header--clickable {
  cursor: pointer;
}

.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) {
  box-shadow: inset 0 0 0 4px var(--accent-primary);
}

.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) .profile-header-overlay {
  background: transparent;
}

.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) .profile-avatar {
  filter: brightness(0.5);
}

.profile-header--clickable:has(.profile-avatar:hover) .profile-header-overlay {
  background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.85));
}

.profile-header-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.3));
  border-radius: 12px 12px 0 0;
}

.profile-info {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 20px;
  margin-top: 0;
  position: relative;
}

.profile-info-top {
  display: flex;
  align-items: flex-end;
  position: relative;
  z-index: 2;
}

.edit-profile-btn {
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-primary);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.edit-profile-btn:hover {
  border-color: var(--accent-hover);
  background: color-mix(in oklab, var(--accent-primary) 24%, transparent);
}
.edit-profile-btn:active {
  transform: translateY(0);
}

.profile-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid var(--bg-secondary);
  object-fit: cover;
  margin-bottom: 0;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease, border-color 0.2s ease;
}

.profile-avatar:hover {
  transform: scale(1.03);
  filter: brightness(0.85);
  border-color: var(--accent-hover);
}

.profile-details {
  margin-top: 10px;
}

.profile-name {
  font-size: 1.5rem;
  margin: 0 0 5px 0;
  color: var(--text-primary);
}

.profile-identity-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.profile-identity-text {
  min-width: 0;
}

.profile-add-to-list-btn {
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-primary);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.profile-add-to-list-btn:hover {
  border-color: var(--accent-hover);
  background: color-mix(in oklab, var(--accent-primary) 24%, transparent);
}
.profile-add-to-list-btn:active {
  transform: translateY(0);
}

.profile-username {
  color: var(--text-secondary);
  font-size: 1rem;
  margin-bottom: 10px;
}

@media (max-width: 640px) {
  .profile-identity-row {
    flex-direction: column;
    align-items: stretch;
  }

  .profile-add-to-list-btn {
    align-self: flex-start;
  }
}

.profile-bio {
  color: var(--text-primary);
  line-height: 1.5;
  margin: 15px 0;
}

.profile-stats {
  display: flex;
  gap: 30px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.profile-stats-action {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.profile-mana-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 15px 0 20px;
  padding: 12px 16px;
  background: var(--bg-tertiary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.profile-mana-bar-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.profile-mana-label {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.profile-mana-track {
  width: 100%;
  height: 6px;
  background: var(--hover-bg, #333);
  border-radius: 999px;
  overflow: hidden;
}

.profile-mana-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.profile-mana-fill.voting {
  background: var(--primary-color);
}

.profile-mana-fill.rc {
  background: #17a2b8;
}

.profile-mana-refresh {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.profile-mana-refresh:hover {
  background: var(--border-color);
  color: var(--text-primary);
}

.profile-mana-refresh svg {
  width: 18px;
  height: 18px;
}

.profile-mana-refresh.refreshing svg {
  animation: spin 1s linear infinite;
}

.profile-mute-btn {
  padding: 8px 16px;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.profile-mute-btn:hover {
  color: var(--error-color);
  border-color: var(--error-color);
  background: var(--error-bg);
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat strong {
  font-size: 1.2rem;
  color: var(--text-primary);
}

.stat span {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.stat-link {
  font-size: 0.9rem;
  color: var(--text-secondary);
  text-decoration: none;
}

.stat-link:hover {
  color: var(--accent-primary);
  text-decoration: underline;
}

.follow-btn {
  padding: 10px 24px;
  background: var(--accent-primary);
  color: var(--bg-secondary);
  border: none;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 10px;
}

.follow-btn:hover {
  background: var(--accent-hover);
}

.follow-btn.following {
  background: var(--border-color);
  color: var(--text-primary);
}

.follow-btn.following:hover {
  background: var(--error-bg);
  color: var(--error-color);
}

.wallet-info-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--bg-tertiary) 100%);
  color: var(--text-primary);
  border: none;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 10px;
  font-size: 15px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.wallet-info-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.wallet-info-btn:active {
  transform: translateY(0);
}

.profile-posts {
  margin-top: 20px;
}

.profile-pinned-post-wrap {
  margin-bottom: 10px;
}

.profile-pinned-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: color-mix(in oklab, var(--accent-primary) 14%, transparent);
  color: var(--text-primary);
  font-size: 0.75rem;
  font-weight: 700;
}

.profile-pinned-badge-icon {
  font-size: 0.8rem;
  line-height: 1;
}

.profile-pinned-badge-label {
  line-height: 1;
}

.content-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 4px;
  border-bottom: 2px solid var(--border-color);
}

.content-tabs .tab-btn {
  flex: 1 1;
  text-align: center;
}

.profile-posts .feed-tabs {
  margin-bottom: 20px;
}

.profile-posts .post-filter-tabs {
  margin-top: -14px;
  margin-bottom: 16px;
}

.profile-posts .feed-tab {
  border-bottom-color: var(--border-color);
}

.profile-pinned-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 14px 0 26px;
}

.profile-pinned-toggle-row div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-pinned-toggle-label {
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
}

.profile-pinned-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 84px;
  height: 30px;
  padding: 4px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: var(--bg-tertiary);
  cursor: pointer;
}

.profile-pinned-option {
  z-index: 2;
  flex: 1 1;
  text-align: center;
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--text-secondary);
}

.profile-pinned-option.active {
  color: var(--text-primary);
}

.profile-pinned-slider {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  border-radius: 999px;
  background: var(--bg-secondary);
  transition: transform 0.2s ease;
}

.profile-pinned-toggle.on .profile-pinned-slider {
  transform: translateX(100%);
}

.profile-sync-status {
  margin: -4px 0 12px;
  color: var(--text-secondary);
  font-size: 0.82rem;
  text-align: right;
}

:root[data-maincontent="wide"] .profile-posts > h3, :root[data-maincontent="wide"] .profile-posts .posts-list {
  padding-left:20px;
  padding-right: 20px;
}

.tab-btn {
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: -2px;
}

.tab-btn:hover {
  color: var(--accent-primary);
  background: var(--bg-tertiary);
}

.tab-btn.active {
  color: var(--accent-primary);
  border-bottom-color: var(--accent-primary);
}

.source-badge {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 400;
  margin-left: 6px;
}

.sub-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.sub-tab-btn {
  padding: 8px 16px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  color: var(--text-secondary);
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
}

.sub-tab-btn:hover {
  background: var(--border-color);
  color: var(--text-primary);
}

.sub-tab-btn.active {
  background: var(--accent-primary);
  color: var(--bg-secondary);
  border-color: var(--accent-primary);
}

.profile-posts h3 {
  color: var(--text-primary);
}

.load-more-container {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  padding: 0 20px;
}

.load-more-btn {
  padding: 12px 32px;
  background: var(--accent-primary);
  color: var(--bg-secondary);
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(29, 161, 242, 0.2);
}

.load-more-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(29, 161, 242, 0.3);
}

.load-more-btn:disabled {
  background: var(--text-tertiary);
  cursor: not-allowed;
  box-shadow: none;
}

.end-message {
  text-align: center;
  padding: 20px;
  margin: 20px 0;
  color: var(--text-secondary);
  font-size: 14px;
  font-style: italic;
}

.end-message {
  text-align: center;
  padding: 20px;
  margin: 20px 0;
  color: var(--text-secondary);
  font-size: 14px;
  font-style: italic;
}

.tab-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.tab-loading p {
  margin-top: 16px;
  font-size: 14px;
  color: var(--text-secondary);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--accent-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.sub-tab-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.raw-toggle {
  padding: 8px 16px;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }

  .profile-feed-selector.mobile-only {
    display: block !important;
  }

  .posts-list, .profile-posts h3 {
    padding: 0 10px;
  }
}

.raw-toggle:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.raw-data-block {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  padding: 12px;
  border-radius: 6px;
  overflow: auto;
  max-height: 360px;
  margin-top: 12px;
  font-size: 12px;
}

@media (max-width: 768px) {
  
  .profile-avatar {
    width: 90px;
    height: 90px;
  }

  .profile-name {
    font-size: 1.3rem;
  }

  .profile-stats {
    gap: 20px;
  }

  .profile-stats-action {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }

  .profile-mana-container {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .profile-mana-refresh {
    align-self: center;
    padding: 6px;
  }

  .stat strong {
    font-size: 1rem;
  }
  
  .load-more-btn {
    padding: 10px 24px;
    font-size: 14px;
  }
}
.mana-progress.loading, .profile-mana-track.loading {
  animation: manaPulse 1.5s infinite ease-in-out;
  background-color: var(--border-color);
}
@keyframes manaPulse {
  0% { opacity: 0.6; }
  50% { opacity: 0.3; }
  100% { opacity: 0.6; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserProfile.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oEAAoE;EACpE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,iCAAiC;EACjC,uEAAuE;AACzE;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,iCAAiC;EACjC,uEAAuE;AACzE;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sFAAsF;EACtF,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,uEAAuE;EACvE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;AACA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,YAAY,EAAE;EACpB,OAAO,YAAY,EAAE;AACvB","sourcesContent":[".profile-feed-selector.mobile-only {\r\n  display: none !important;\r\n  padding: 8px 10px;\r\n}\r\n\r\n.profile-container {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.profile-feed-selector {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.profile-feed-dropdown {\r\n  width: 100%;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.profile-feed-dropdown option {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.profile-header {\r\n  aspect-ratio: 4680 / 1220;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-color: var(--accent-primary);\r\n  border-radius: 12px 12px 0 0;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding: 20px;\r\n  transition: box-shadow 0.2s ease;\r\n}\r\n\r\n.profile-header--clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) {\r\n  box-shadow: inset 0 0 0 4px var(--accent-primary);\r\n}\r\n\r\n.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) .profile-header-overlay {\r\n  background: transparent;\r\n}\r\n\r\n.profile-header--clickable:hover:not(:has(.profile-info-top:hover)) .profile-avatar {\r\n  filter: brightness(0.5);\r\n}\r\n\r\n.profile-header--clickable:has(.profile-avatar:hover) .profile-header-overlay {\r\n  background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.85));\r\n}\r\n\r\n.profile-header-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.3));\r\n  border-radius: 12px 12px 0 0;\r\n}\r\n\r\n.profile-info {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-top: none;\r\n  border-radius: 0 0 12px 12px;\r\n  padding: 20px;\r\n  margin-top: 0;\r\n  position: relative;\r\n}\r\n\r\n.profile-info-top {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.edit-profile-btn {\r\n  border: 1px solid var(--border-color);\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  border-radius: 999px;\r\n  padding: 8px 14px;\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.edit-profile-btn:hover {\r\n  border-color: var(--accent-hover);\r\n  background: color-mix(in oklab, var(--accent-primary) 24%, transparent);\r\n}\r\n.edit-profile-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.profile-avatar {\r\n  width: 120px;\r\n  height: 120px;\r\n  border-radius: 50%;\r\n  border: 4px solid var(--bg-secondary);\r\n  object-fit: cover;\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, filter 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.profile-avatar:hover {\r\n  transform: scale(1.03);\r\n  filter: brightness(0.85);\r\n  border-color: var(--accent-hover);\r\n}\r\n\r\n.profile-details {\r\n  margin-top: 10px;\r\n}\r\n\r\n.profile-name {\r\n  font-size: 1.5rem;\r\n  margin: 0 0 5px 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.profile-identity-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.profile-identity-text {\r\n  min-width: 0;\r\n}\r\n\r\n.profile-add-to-list-btn {\r\n  border: 1px solid var(--border-color);\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  border-radius: 999px;\r\n  padding: 8px 14px;\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.profile-add-to-list-btn:hover {\r\n  border-color: var(--accent-hover);\r\n  background: color-mix(in oklab, var(--accent-primary) 24%, transparent);\r\n}\r\n.profile-add-to-list-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.profile-username {\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .profile-identity-row {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .profile-add-to-list-btn {\r\n    align-self: flex-start;\r\n  }\r\n}\r\n\r\n.profile-bio {\r\n  color: var(--text-primary);\r\n  line-height: 1.5;\r\n  margin: 15px 0;\r\n}\r\n\r\n.profile-stats {\r\n  display: flex;\r\n  gap: 30px;\r\n  margin: 20px 0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.profile-stats-action {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.profile-mana-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin: 15px 0 20px;\r\n  padding: 12px 16px;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.profile-mana-bar-wrapper {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.profile-mana-label {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.profile-mana-track {\r\n  width: 100%;\r\n  height: 6px;\r\n  background: var(--hover-bg, #333);\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.profile-mana-fill {\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.profile-mana-fill.voting {\r\n  background: var(--primary-color);\r\n}\r\n\r\n.profile-mana-fill.rc {\r\n  background: #17a2b8;\r\n}\r\n\r\n.profile-mana-refresh {\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.profile-mana-refresh:hover {\r\n  background: var(--border-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.profile-mana-refresh svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.profile-mana-refresh.refreshing svg {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.profile-mute-btn {\r\n  padding: 8px 16px;\r\n  background: none;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 999px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.profile-mute-btn:hover {\r\n  color: var(--error-color);\r\n  border-color: var(--error-color);\r\n  background: var(--error-bg);\r\n}\r\n\r\n.stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.stat strong {\r\n  font-size: 1.2rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.stat span {\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.stat-link {\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n}\r\n\r\n.stat-link:hover {\r\n  color: var(--accent-primary);\r\n  text-decoration: underline;\r\n}\r\n\r\n.follow-btn {\r\n  padding: 10px 24px;\r\n  background: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  margin-top: 10px;\r\n}\r\n\r\n.follow-btn:hover {\r\n  background: var(--accent-hover);\r\n}\r\n\r\n.follow-btn.following {\r\n  background: var(--border-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.follow-btn.following:hover {\r\n  background: var(--error-bg);\r\n  color: var(--error-color);\r\n}\r\n\r\n.wallet-info-btn {\r\n  padding: 10px 24px;\r\n  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--bg-tertiary) 100%);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  margin-top: 10px;\r\n  font-size: 15px;\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.wallet-info-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n.wallet-info-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.profile-posts {\r\n  margin-top: 20px;\r\n}\r\n\r\n.profile-pinned-post-wrap {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.profile-pinned-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin: 0 0 8px 6px;\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  background: color-mix(in oklab, var(--accent-primary) 14%, transparent);\r\n  color: var(--text-primary);\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.profile-pinned-badge-icon {\r\n  font-size: 0.8rem;\r\n  line-height: 1;\r\n}\r\n\r\n.profile-pinned-badge-label {\r\n  line-height: 1;\r\n}\r\n\r\n.content-tabs {\r\n  display: flex;\r\n  gap: 0;\r\n  margin-bottom: 4px;\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.content-tabs .tab-btn {\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.profile-posts .feed-tabs {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.profile-posts .post-filter-tabs {\r\n  margin-top: -14px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.profile-posts .feed-tab {\r\n  border-bottom-color: var(--border-color);\r\n}\r\n\r\n.profile-pinned-toggle-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin: 14px 0 26px;\r\n}\r\n\r\n.profile-pinned-toggle-row div {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.profile-pinned-toggle-label {\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.profile-pinned-toggle {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-width: 84px;\r\n  height: 30px;\r\n  padding: 4px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 999px;\r\n  background: var(--bg-tertiary);\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-pinned-option {\r\n  z-index: 2;\r\n  flex: 1;\r\n  text-align: center;\r\n  font-size: 0.74rem;\r\n  font-weight: 700;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.profile-pinned-option.active {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.profile-pinned-slider {\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 4px;\r\n  width: calc(50% - 4px);\r\n  height: calc(100% - 8px);\r\n  border-radius: 999px;\r\n  background: var(--bg-secondary);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.profile-pinned-toggle.on .profile-pinned-slider {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.profile-sync-status {\r\n  margin: -4px 0 12px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.82rem;\r\n  text-align: right;\r\n}\r\n\r\n:root[data-maincontent=\"wide\"] .profile-posts > h3, :root[data-maincontent=\"wide\"] .profile-posts .posts-list {\r\n  padding-left:20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.tab-btn {\r\n  padding: 12px 24px;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  margin-bottom: -2px;\r\n}\r\n\r\n.tab-btn:hover {\r\n  color: var(--accent-primary);\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.tab-btn.active {\r\n  color: var(--accent-primary);\r\n  border-bottom-color: var(--accent-primary);\r\n}\r\n\r\n.source-badge {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 400;\r\n  margin-left: 6px;\r\n}\r\n\r\n.sub-tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sub-tab-btn {\r\n  padding: 8px 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 20px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.sub-tab-btn:hover {\r\n  background: var(--border-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sub-tab-btn.active {\r\n  background: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.profile-posts h3 {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.load-more-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 30px 0;\r\n  padding: 0 20px;\r\n}\r\n\r\n.load-more-btn {\r\n  padding: 12px 32px;\r\n  background: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n  border: none;\r\n  border-radius: 24px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0 2px 4px rgba(29, 161, 242, 0.2);\r\n}\r\n\r\n.load-more-btn:hover:not(:disabled) {\r\n  background: var(--accent-hover);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 8px rgba(29, 161, 242, 0.3);\r\n}\r\n\r\n.load-more-btn:disabled {\r\n  background: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.end-message {\r\n  text-align: center;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n.end-message {\r\n  text-align: center;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n.tab-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.tab-loading p {\r\n  margin-top: 16px;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid var(--border-color);\r\n  border-top: 4px solid var(--accent-primary);\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.sub-tab-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.raw-toggle {\r\n  padding: 8px 16px;\r\n  background: none;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  margin-top: 10px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .desktop-only {\r\n    display: none !important;\r\n  }\r\n\r\n  .profile-feed-selector.mobile-only {\r\n    display: block !important;\r\n  }\r\n\r\n  .posts-list, .profile-posts h3 {\r\n    padding: 0 10px;\r\n  }\r\n}\r\n\r\n.raw-toggle:hover {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.raw-data-block {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  padding: 12px;\r\n  border-radius: 6px;\r\n  overflow: auto;\r\n  max-height: 360px;\r\n  margin-top: 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  \r\n  .profile-avatar {\r\n    width: 90px;\r\n    height: 90px;\r\n  }\r\n\r\n  .profile-name {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .profile-stats {\r\n    gap: 20px;\r\n  }\r\n\r\n  .profile-stats-action {\r\n    margin-left: 0;\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .profile-mana-container {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .profile-mana-refresh {\r\n    align-self: center;\r\n    padding: 6px;\r\n  }\r\n\r\n  .stat strong {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .load-more-btn {\r\n    padding: 10px 24px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n.mana-progress.loading, .profile-mana-track.loading {\n  animation: manaPulse 1.5s infinite ease-in-out;\n  background-color: var(--border-color);\n}\n@keyframes manaPulse {\n  0% { opacity: 0.6; }\n  50% { opacity: 0.3; }\n  100% { opacity: 0.6; }\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
